const isValidCpf = (cpf: string) => {
    const digits = cpf.trim().split('')

    if (digits.every((digit) => digit === digits[0])) {
        return false
    }

    let v1 = 0
    for (let i = 0, p = 10; digits.length - 2 > i; i++, p--) {
        v1 += +digits[i] * p
    }
    v1 = (v1 * 10) % 11
    if (v1 == 10) {
        v1 = 0
    }
    if (v1 !== +digits[9]) {
        return false
    }

    let v2 = 0
    for (let i = 0, p = 11; digits.length - 1 > i; i++, p--) {
        v2 += +digits[i] * p
    }
    v2 = (v2 * 10) % 11
    if (v2 == 10) {
        v2 = 0
    }

    return v2 === +digits[10]
}

const isValidCnpj = (cnpj: string) => {
    const digits = cnpj.trim().split('')

    if (digits.every((digit) => digit === digits[0])) {
        return false
    }

    let v1 = 0
    for (let i = 0, p1 = 5, p2 = 13; digits.length - 2 > i; i++, p1--, p2--) {
        v1 += +digits[i] * (p1 >= 2 ? p1 : p2)
    }
    v1 = v1 % 11
    v1 = v1 < 2 ? 0 : 11 - v1
    if (v1 !== +digits[12]) {
        return false
    }

    let v2 = 0
    for (let i = 0, p1 = 6, p2 = 14; digits.length - 1 > i; i++, p1--, p2--) {
        v2 += +digits[i] * (p1 >= 2 ? p1 : p2)
    }
    v2 = v2 % 11
    v2 = v2 < 2 ? 0 : 11 - v2

    return v2 === +digits[13]
}

const validateCpfCnpj = (cpfCnpj: string) => {
    if (!cpfCnpj) {
        return false
    }
    if (cpfCnpj.length === 11) {
        return isValidCpf(cpfCnpj)
    }
    if (cpfCnpj.length === 14) {
        return isValidCnpj(cpfCnpj)
    }
    return false
}

export const Documents = { validateCpfCnpj }
